<template>
  <span :title="$gettext('Soft mobility outing')">
    <fa-icon icon="bus"></fa-icon>
  </span>
</template>
